import React, { useCallback, useContext, useEffect, useRef } from "react";

//Data contexts
import { InterviewFormContext } from "../../hooks/InterviewFormContext";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";

//React components
import { GoalAchievementTarget } from "./GoalAchievementTarget";
import { GoalAchievementThreshold } from "./GoalAchievementThreshold";
import { GoalOccurrence } from "../../common/components/GoalOccurrence";
import { GoalNameInput } from "../../common/components/GoalNameInput";
import { InterviewSelector } from "./InterviewSelector";

//JS Classes
import { InterviewGoalTemplate } from "../../classes/goal_template_interview_class";
import { InterviewFormPropsShape } from "../../interfaces/componentTypes";
import { GoalDescriptionInput } from "../../common/components/GoalDescriptionInput";
import { LeaderBoardSelector } from "../../common/components/LeaderBoardSelector";

export const InterviewForm: React.FunctionComponent<InterviewFormPropsShape> = ({
  setStepComplete,
}) => {
  const { DBObject } = useContext(TMDataContext);
  const { goalState, setGoalState } = useContext(InterviewFormContext);

  //Detect if Form is complete
  useEffect(() => {
    setStepComplete(InterviewGoalTemplate.complete(goalState));
  }, [goalState]);

  const handleGoalName = useCallback((e) => {
    e.persist();
    setGoalState((prevState) => {
      return {
        ...prevState,
        name: e.target.value,
      };
    });
  }, []);

  const handleGoalDescription = useCallback((e) => {
    e.persist();
    setGoalState((prevState) => {
      return {
        ...prevState,
        description: e.target.value,
      };
    });
  }, []);

  const handleLeaderboardSelection = useCallback((value) => {
    value.persist();
    setGoalState((prevState) => {
      return {
        ...prevState,
        leaderboardEnabled: value.target.checked,
      };
    });
  }, []);

  return (
    <>
      <div className="row wor-100" style={{ flex: 1 }}>
        <div className="col-md-12 col-sm-6">
          <GoalNameInput
            handleGoalName={handleGoalName}
            input={goalState.name}
            user={goalState.user}
            type={goalState.type}
            characterLimit={DBObject.ConfigVariables.goal_name_character_limit}
          />
          <GoalDescriptionInput
            input={goalState.description}
            handleGoalDescription={handleGoalDescription}
            characterLimit={DBObject.ConfigVariables.goal_name_character_limit}
          />
          <InterviewSelector />
          <GoalAchievementTarget contextOrigin={InterviewFormContext} />
          <GoalAchievementThreshold contextOrigin={InterviewFormContext} />
          <GoalOccurrence
            approved={true}
            contextOrigin={InterviewFormContext}
          />
          {DBObject.ConfigVariables.leaderboards_enabled == "true" ? (
            <LeaderBoardSelector
              handleLeaderboardSelection={handleLeaderboardSelection}
              leaderboardStatus={goalState.leaderboardEnabled}
              approved={true}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};
